import React from 'react'
import Header from '../../Header/Header'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../innerpage.css'
import {Row, Container, Col} from 'react-bootstrap'

import usaguideline from '../../../images/usaguideline.png'

const ausBanner = () => {
  return (
    <>
        <div className='innerbanner pt-4 ausbanner'>
                <Header></Header>
                <div className='container-fluid'>
                <Container>
                <Row className='d-flex justify-content-center align-items-center'>                    
                    <Col md={5}>
                        <img src={usaguideline} alt="ausbanner" className='animated2 infinite fadeInLeftRight'></img>                        
                    </Col>
                    <Col md={7}>
                            <h2>Study in <span>Australia</span></h2>
                            <p>Your journey begins the minute you decide to go abroad.  </p>
                    </Col>
                </Row>
            </Container>
                </div>
            </div>
    </>
  )
}

export default ausBanner